import { Component, Input } from '@angular/core'
import { MachineStateComputed } from '../../../../models/states-computed.models'
import { LoadStatus, State } from '../../../../models/states.models'
import { TouaregControlMessageDialogComponent } from '../touareg-control-message-dialog/touareg-control-message-dialog.component'
import { Samv2Module } from '@aubert-et-duval/samv2';

@Component({
  selector: 'app-touareg-control-state-assets',
  templateUrl: './touareg-control-state-assets.component.html',
  styleUrls: ['./touareg-control-state-assets.component.scss'],
  imports: [Samv2Module],
})
export class TouaregControlStateAssetsComponent {
  @Input()
  set state(currentState: MachineStateComputed) {
    this._storeData(currentState)
  }

  public pickNumber: number | null = null
  public displayState!: 'none' | 'novalues' | 'loading' | 'pickNumber'

  constructor() {}

  private _storeData(state: MachineStateComputed) {
    switch (state?.state) {
      case State.IDLE:
        this.pickNumber = null
        this.displayState = 'none'
        break

      case State.PICKING_SCANNING:
        this.pickNumber = this._getPickNumber(state)
        this.displayState = 'loading'
        break

      case State.PICKED:
        this.pickNumber = this._getPickNumber(state)
        this.displayState = 'pickNumber'
        break

      case State.DROP_SCANNING:
        this.pickNumber = this._getPickNumber(state)
        this.displayState = 'loading'
        break

      case State.DROP_ACCEPTING_USER_CHOICE:
      case State.DROP_BLOCKED_BY_USER:
        this.pickNumber = this._getPickNumber(state)
        this.displayState = 'pickNumber'
        break

      default:
        this.pickNumber = null
        this.displayState = 'none'
    }
  }

  private _getPickNumber(state: MachineStateComputed): number | null {
    let count = null
    if (state?.tags_list) {
      count = state.tags_list.filter(
        (t) => t.load_status === LoadStatus.loaded
      ).length
    }
    return count
  }
}
